import intl from 'react-intl-universal';
import { useState, useEffect } from 'react';
import { Select, List, Row, Col, message, Tag, Popconfirm } from 'antd';
// import type { ChangeEvent } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';
import { debounce } from 'lodash';
import {
    getSeriesByName,
    getProductBySeriesName,
    getAccessoryList,
} from '@/api/common';
import moment from 'moment';
import { default as Modal } from '@/components/CssModal';

import defaultLogo from '@/assets/default-logo.png';

import style from './index.less';
interface Props {
    /**
     * accessory : 配件
     */
    mode?: 'accessory';
    initValue?: {
        [key: string]: any;
    };
    // onChange: React.ChangeEventHandler<HTMLInputElement>;
    commoditys: any[];
    // pay_at: string;
    show: boolean;
    onSave?: (value: { [key: string]: string }) => void;
    onClose?: () => void;
}

const SelectNewGoods: React.FC<Props> = (props) => {
    const { commoditys, show, initValue, mode, onSave, onClose } = props;
    const [loading, setLoading] = useState(false);
    const [seriesList, setSeriesList] = useState<any[]>();
    const [productList, setProductList] = useState<any[]>([]);
    const [currentItemNo, setCurrentItemNo] = useState<string>(null);
    const [value, setValue] = useState<{ [key: string]: any }>(initValue || {});

    useEffect(() => {
        if (show) {
            setValue(initValue || {});
            onSelectOld(commoditys[0]);
        }
    }, [show]);

    const handleSearch = debounce((newValue: string) => {
        if (newValue) {
            getSeriesByName(newValue).then((res: { series_name: string }[]) => {
                if (res?.length > 200) {
                    setSeriesList(res.slice(0, 200));
                } else {
                    setSeriesList(res || []);
                }
            });
        } else {
            setSeriesList([]);
        }
    }, 500);

    const searchCommoditysBySeriesName = (value: string) => {
        setLoading(true);
        getProductBySeriesName(value).then((res) => {
            setProductList(res || []);
            setLoading(false);
        });
    };

    const searchAccessory = (product_code: string) => {
        setLoading(true);
        getAccessoryList(product_code).then((res) => {
            setLoading(false);
            console.log(res);
            setProductList(res || []);
        });
    };

    const onSelectOld = (item: any) => {
        if (currentItemNo !== item.id) {
            setCurrentItemNo(item.id);
            if (mode === 'accessory') {
                searchAccessory(
                    // '111100001' ||
                    item.aftersale_goods_info?.product_code ||
                        item.product_code,
                );
            } else {
                searchCommoditysBySeriesName(
                    item.aftersale_goods_info?.series_name || item.series_name,
                );
            }
        } else {
            setCurrentItemNo('');
        }
    };
    const onSelectNew = (item: any) => {
        if (!currentItemNo) {
            message.warning(
                intl.get('请先选择一个原商品之后选择{slot1}', {
                    slot1:
                        mode === 'accessory'
                            ? intl.get('配件')
                            : intl.get('新商品'),
                }),
            );
            return;
        }
        let stock = item.available_stock;
        if (mode === 'accessory') {
            stock = item.stock;
        }

        if (stock <= 1) {
            message.warning(
                intl.get('该{slot1}库存不足，请选择其他商品', {
                    slot1:
                        mode === 'accessory'
                            ? intl.get('配件')
                            : intl.get('新商品'),
                }),
            );
            return;
        }

        setValue({
            ...value,
            [currentItemNo]: item,
        });
    };
    const removeNew = (e, item: any) => {
        // console.log(item, value);
        e.stopPropagation();
        delete value[item.id];
        setValue({
            ...value,
        });
    };

    const handleOk = () => {
        console.log(value);
        const selectItems = Object.keys(value).filter((item) => !!value[item]);
        if (selectItems.length !== commoditys.length) {
            const missCommodity = commoditys.find(
                (item) => !selectItems.includes(item.item_no),
            );
            return message.error(
                intl.get('{slot1}商品还有未选择换{slot2}，请选择后提交', {
                    slot1: missCommodity.name,
                    slot2:
                        mode === 'accessory'
                            ? intl.get('配件')
                            : intl.get('新商品'),
                }),
            );
        }
        onSave && onSave(value);
    };

    const renderNewItem = (item: any, isCanSelect: boolean) => {
        return (
            <List.Item
                className={style.commityItem}
                onClick={() => isCanSelect && onSelectNew(item)}
            >
                {item.is_hidden && (
                    <Tag
                        className={style.hiddenTag}
                        color="orange"
                    >
                        {intl.get('隐藏')}
                    </Tag>
                )}
                <div className={style.logoContainer}>
                    <img src={item.toy_image || item.img || defaultLogo} />
                </div>
                <Row className={style.commityContent}>
                    <Col span={16}>{item.toy_name || item.product_name}</Col>
                    <Col
                        span={7}
                        offset={1}
                    >
                        {intl.get('库存：')}

                        {item.available_stock === undefined
                            ? item.stock
                            : item.available_stock}
                    </Col>
                    <Col span={14}>
                        {intl.get('商品SKU :')}
                        {item.product_code}
                    </Col>
                    {mode !== 'accessory' && (
                        <Col span={10}>
                            {moment(item.putaway_time).format('YYYY-MM-DD')}
                        </Col>
                    )}
                </Row>
            </List.Item>
        );
    };

    return (
        <Modal
            title={
                mode === 'accessory'
                    ? intl.get('选择配件')
                    : intl.get('选择新商品')
            }
            open={show}
            onOk={handleOk}
            onCancel={onClose}
            width={1000}
        >
            <Select
                disabled={mode === 'accessory'}
                style={{ width: 400 }}
                allowClear
                showSearch
                placeholder={intl.get('请输入商品/系列名称')}
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                onSearch={handleSearch}
                //   onChange={handleChange}
                onClear={() => setSeriesList([])}
                notFoundContent={null}
                onSelect={searchCommoditysBySeriesName}
                options={(seriesList || []).map((d) => ({
                    value: d.series_name,
                    label: d.series_name,
                }))}
            />

            <div className={style.commoditysContianer}>
                <List
                    className={style.commodityList}
                    size="small"
                    dataSource={commoditys}
                    renderItem={(commityItem) => {
                        // 取最新的商品信息
                        const item = commityItem.aftersale_goods_info || {};
                        const commityId = commityItem.id;
                        return (
                            <List.Item
                                className={`${style.commityItem} ${
                                    currentItemNo === commityItem.id
                                        ? style.currentItem
                                        : ''
                                }`}
                                onClick={() => onSelectOld(commityItem)}
                            >
                                {item.is_hidden && (
                                    <Tag
                                        className={style.hiddenTag}
                                        color="orange"
                                    >
                                        {intl.get('隐藏')}
                                    </Tag>
                                )}
                                <div className={style.logoContainer}>
                                    <img src={item.img || defaultLogo} />
                                </div>

                                <Row className={style.commityContent}>
                                    <Col span={24}>{item.name}</Col>
                                    <Col span={10}>
                                        {intl.get('商品SKU :')}
                                        {item.product_code}
                                    </Col>
                                    <Col span={12}>
                                        {moment(item.putaway_time).format(
                                            'YYYY-MM-DD',
                                        )}
                                    </Col>
                                    <Col span={2}>X{item.num}</Col>
                                </Row>
                                <div className={style.relativeNew}>
                                    {value[commityId] && (
                                        <Row
                                            className={
                                                style.relativeNewContainer
                                            }
                                        >
                                            <Col span={24}>
                                                {value[commityId]?.toy_name ||
                                                    value[commityId]
                                                        ?.product_name}
                                            </Col>

                                            <CloseCircleFilled
                                                onClick={(e) =>
                                                    removeNew(e, commityItem)
                                                }
                                                className={style.closeBtn}
                                            />
                                        </Row>
                                    )}
                                </div>
                            </List.Item>
                        );
                    }}
                ></List>
                <List
                    loading={loading}
                    className={style.commodityList}
                    size="small"
                    dataSource={productList}
                    locale={{
                        emptyText: currentItemNo
                            ? mode === 'accessory'
                                ? intl.get('暂无相关配件')
                                : intl.get('暂无数据')
                            : intl.get('请先选择一个系列'),
                    }}
                    renderItem={(item) => {
                        // i18n-ignore
                        return item.packaging_type === '盲盒' ? (
                            <Popconfirm
                                title={intl.get('该商品是盲盒，确定要选择吗')}
                                onConfirm={() => onSelectNew(item)}
                                cancelText={intl.get('取消')}
                                okText={intl.get('确定')}
                            >
                                {renderNewItem(item, false)}
                            </Popconfirm>
                        ) : (
                            renderNewItem(item, true)
                        );
                    }}
                ></List>
            </div>
            <div className={style.selectCountTip}>
                <span>
                    {intl.get('本次共选中了')}

                    {Object.keys(value || {}).length}
                    {intl.get('件商品')}
                </span>
            </div>
        </Modal>
    );
};

export default SelectNewGoods;
